import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IExecution, ISelectedItem } from '../types/IExecution';

/**
 * Parameters for the VizPortal `triggerExtraction` Web Client method
 * (WebClientContentMobilityAppService.triggerExtraction): queues a background extraction of a plan.
 */
export interface ITriggerExtractionParams {
  planLuid: string;
  /** The items to extract; omit (or empty) to extract the whole plan. */
  selectedItems?: ISelectedItem[];
}

/** Resolves with a QUEUED execution carrying the background job id to poll. */
export class TriggerExtractionRequest extends Request<ITriggerExtractionParams, IExecution> {
  constructor(params: ITriggerExtractionParams) {
    super('triggerExtraction', params);
  }
}
